/**
 * The deployed version, injected at build time from `build-info.json` (see vite.config.ts).
 * `dev` locally, where no build-info exists.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? 'dev';

/**
 * The tag out of a `git describe --tags --long` string: "1.9.0-0-g5eaa4e6a" → "1.9.0".
 *
 * Only the trailing "-<commits>-g<hash>" is stripped, so a tag that contains hyphens of its own
 * ("2.8.0-rc.1") survives intact. Returns null for anything not worth showing a human, which is
 * how the sidebar decides to render no version line at all rather than the word "Unknown".
 */
export function cleanVersionTag(raw: string | undefined | null): string | null {
  const value = raw?.trim();
  if (!value || value === 'Unknown' || value === 'dev') return null;
  return value.replace(/-\d+-g[0-9a-f]+$/i, '');
}
